import { useEffect } from 'react';
import { trackEvent } from '../lib/app/analytics/ga';

/**
 * Tracks the duration a module is mounted.
 * @param {string} module_name The name of the module being tracked.
 * @param {string|null} [view_name=null] Optional view name within the module.
 * @returns {void}
 */
// TODO: Optionally log entry without duration. This way the duration could be calculated after the event was sent to GA4.
export const useModuleDurationTracking = (
  module_name: string,
  view_name: string,
  group_id?: string,
  company_id?: string,
  disabled?: boolean
): void => {
  useEffect(() => {
    if (disabled) return;
    let is_mounted = true;
    const entry_tstamp: number = Date.now();
    return () => {
      if (is_mounted) {
        const exit_tstamp: number = Date.now();
        const open_duration: number = exit_tstamp - entry_tstamp;
        // Log module dismount with duration.
        trackEvent('module_visit', {
          group_id: group_id ?? null,
          company_id: company_id ?? null,
          module_name: module_name,
          ...(view_name ? { view_name } : {}),
          timestamp: exit_tstamp,
          duration_ms: open_duration
        });
        is_mounted = false;
      }
    };
  }, [disabled]);
};
